var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSbs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF6A14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M11.36 20.965H9.796v-9.902h1.562v9.902zm3.868-9.902h-1.562v9.902h1.562v-9.902zm1.488 0h-.78v9.902h.78v-9.902zm3.22 0h-1.561v9.902h1.562v-9.902zm1.282 0h-.507v9.902h.507v-9.902zm1.16 0h-.783v9.902h.78v-9.902h.002zM10.81 6H6v5.063h1.266V7.266h3.544V6zM26 10.81V6h-5.063v1.266h3.797v3.544H26zM21.19 26H26v-5.063h-1.266v3.797H21.19V26zM6 21.19V26h5.063v-1.266H7.266V21.19H6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbs);
export default __webpack_public_path__ + "static/media/sbs.b993433442f757a9bb08186d93decf34.svg";
export { ForwardRef as ReactComponent };